import { Sprout, Handshake, Sun } from "lucide-react";

const VALUES = [
  {
    icon: Sprout,
    title: "Cercanía",
    text: "Producto fresco y de proximidad. Trato directo, como en el mercado de siempre.",
  },
  {
    icon: Handshake,
    title: "Artesanía",
    text: "Selección a mano y atención cuidada. La calidad se nota en cada pieza.",
  },
  {
    icon: Sun,
    title: "Especialidad",
    text: "Especias, frutos secos, café y miel como seña de la casa.",
  },
];

export const About = () => {
  return (
    <section
      id="sobre-nosotros"
      data-testid="about-section"
      className="py-24 md:py-32 bg-[#034638] text-white relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {/* Image collage */}
          <div className="lg:col-span-6 relative">
            <div className="grid grid-cols-12 grid-rows-6 gap-4 h-[520px] md:h-[640px]">
              <img
                src="https://images.unsplash.com/photo-1610348725531-843dff563e2c?auto=format&fit=crop&w=1400&q=90"
                alt="Cesta con producto fresco variado"
                className="col-span-7 row-span-4 w-full h-full object-cover"
              />
              <img
                src="https://images.unsplash.com/photo-1488459716781-31db52582fe9?auto=format&fit=crop&w=1000&q=90"
                alt="Pimientos de colores"
                className="col-span-5 row-span-3 col-start-8 w-full h-full object-cover"
              />
              <img
                src="https://images.unsplash.com/photo-1592924357228-91a4daadcfea?auto=format&fit=crop&w=1000&q=90"
                alt="Tomates Raf"
                className="col-span-5 row-span-3 col-start-8 row-start-4 w-full h-full object-cover"
              />
              <div className="col-span-7 row-span-2 row-start-5 bg-[#034638] text-white flex items-center justify-between gap-4 px-7 py-6">
                <div className="flex flex-col leading-none">
                  <span className="font-display text-3xl md:text-4xl tracking-tight">
                    Zoco <span className="italic">Fruits</span>
                  </span>
                  <span className="font-sans-z text-[9px] tracking-[0.32em] uppercase mt-2.5 text-white/75">
                    Fruits &amp; Vegetables Delivery
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Text */}
          <div className="lg:col-span-6 lg:pl-6">
            <p className="font-sans-z text-[10px] uppercase tracking-[0.32em] font-semibold text-[#7DB7B0] mb-5">
              Sobre nosotros
            </p>
            <h2 className="font-display text-5xl md:text-6xl lg:text-7xl tracking-tight text-white leading-[1.0] mb-8">
              Una frutería<br />
              <span className="italic text-[#7DB7B0]">selecta.</span>
            </h2>
            <div className="space-y-5 font-sans-z text-base md:text-lg text-white/85 leading-relaxed max-w-xl">
              <p>
                <span className="font-semibold">Zoco</span> — del árabe <em>sūq</em>, "mercado".
                Una palabra que evoca cercanía, oficio y producto que pasa por
                muchas manos antes de llegar a la mesa.
              </p>
              <p>
                Trabajamos con producto fresco, de cercanía y elegido a mano,
                pieza a pieza, como se ha hecho siempre. Especias y frutos secos
                como nuestra seña de la casa, junto a fruta de temporada,
                verdura, café de especialidad y miel.
              </p>
            </div>

            {/* Values */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 mt-14">
              {VALUES.map((v) => {
                const Icon = v.icon;
                return (
                  <div key={v.title} className="border-t border-white/25 pt-6">
                    <Icon size={26} strokeWidth={1.6} className="text-[#7DB7B0] mb-4" />
                    <h3 className="font-display text-2xl tracking-tight text-white mb-2">
                      {v.title}
                    </h3>
                    <p className="font-sans-z text-sm text-white/75 leading-relaxed">
                      {v.text}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
